var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisualinspectionandaudio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#455768"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16895 3.41667C9.82822 3.41667 10.4727 3.61216 11.0208 3.97843C11.569 4.34471 11.9963 4.8653 12.2485 5.47439C12.5008 6.08348 12.5668 6.7537 12.4382 7.4003C12.3096 8.0469 11.9921 8.64085 11.526 9.10702C11.0598 9.5732 10.4659 9.89067 9.81925 10.0193C9.17265 10.1479 8.50242 10.0819 7.89334 9.8296C7.28425 9.57731 6.76365 9.15006 6.39738 8.6019C6.03111 8.05374 5.83561 7.40927 5.83561 6.75C5.83561 5.86594 6.1868 5.0181 6.81192 4.39298C7.43705 3.76786 8.28489 3.41667 9.16895 3.41667V3.41667ZM9.16895 3C8.42727 3 7.70224 3.21993 7.08556 3.63199C6.46887 4.04404 5.98823 4.62971 5.7044 5.31494C5.42057 6.00016 5.34631 6.75416 5.491 7.48159C5.6357 8.20902 5.99285 8.8772 6.5173 9.40165C7.04174 9.9261 7.70993 10.2833 8.43736 10.4279C9.16479 10.5726 9.91879 10.4984 10.604 10.2145C11.2892 9.93072 11.8749 9.45007 12.287 8.83339C12.699 8.2167 12.9189 7.49168 12.9189 6.75C12.9189 6.25754 12.822 5.76991 12.6335 5.31494C12.445 4.85997 12.1688 4.44657 11.8206 4.09835C11.4724 3.75013 11.059 3.47391 10.604 3.28545C10.149 3.097 9.6614 3 9.16895 3V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8771 6.74984C11.8771 8.24561 10.6646 9.45817 9.16878 9.45817C7.67301 9.45817 6.46045 8.24561 6.46045 6.74984C6.46045 5.25407 7.67301 4.0415 9.16878 4.0415C10.6646 4.0415 11.8771 5.25407 11.8771 6.74984ZM7.77917 6.97068L8.89584 8.08943L10.5354 6.44985L10.0938 6.00818L8.89584 7.20401L8.22084 6.52901L7.77917 6.97068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81915 10.9816L2.98535 11.8154L4.3097 13.1398L5.1435 12.306L3.81915 10.9816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9376 10.5146L5.76885 11.6834L4.44385 10.3584L5.56885 9.2334C5.92715 9.75437 6.39412 10.1915 6.9376 10.5146V10.5146Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisualinspectionandaudio);
export default __webpack_public_path__ + "static/media/icon_Visual inspection and audio.bafa6de0651c731695ca074435bc499a.svg";
export { ForwardRef as ReactComponent };